module.exports = __webpack_public_path__ + "static/img/rexiao.eaea7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/rexiao.png
// module id = 1259
// module chunks = 0